module.exports = __webpack_public_path__ + "images/jwo-logo-light.png";